export default "__VITE_ASSET__BqdJpzIj__"